import { AbortSignal } from "./AbortSignal";
export class AbortController {
    constructor() {
        this.signal = new AbortSignal();
    }
    abort() {
        this.signal.abort();
    }
}
